export default {
  menu: {
    dashboard: "Dashboard",
    projects: "Projects",
    architectures: "Architectures",
    templates: "Templates",
    cloudServices: "Cloud Services",
    finops: "FinOps",
    monitoring: "Monitoring",
    gettingStarted: "Getting Started",
    settings: "Settings",
    help: "Help",
    documentation: "Documentation",
    profile: "Profile",
    logout: "Logout"
  },
  sidebar: {
    overview: "Overview",
    myProjects: "My projects",
    recentArchitectures: "Recent architectures",
    favorites: "Favorites",
    shared: "Shared",
    archived: "Archived"
  }
};
